import { H3 } from '@components/Common.styles';
import { ClientTableV2 } from '@components/TableV2/ClientTableV2';
import { useI18n } from '@hooks/useI18n/useI18n';
import { IApplicationDocuments } from '@schemas/merchantPortal/types/orderApplicationDetails';
import {
  getApplicationDocumentsColumns,
  mapApplicationDocumentData,
} from './utils';

interface IApplicationDocumentsTable {
  documents: IApplicationDocuments | undefined;
}

export const ApplicationDocumentsTable = ({
  documents,
}: IApplicationDocumentsTable) => {
  const { getLocaleDate, translate } = useI18n();

  const columns = getApplicationDocumentsColumns(translate);
  const data = mapApplicationDocumentData({
    data: documents,
    getLocaleDate,
    translate,
  });

  return (
    <>
      <H3>{translate('LABEL.CUSTOMER_DOCUMENTS_UPLOADED')}</H3>

      <ClientTableV2
        columns={columns}
        data={data}
        name="customer documents uploaded"
        wrapTableInCard={false}
      />
    </>
  );
};
